function showPreloadedTrial()//preload images before each trial (is it really needed if I preload everything at the start?)
{
  for (var iImage = 0; iImage < imageColumns.length; iImage++)//maximum possible images in one trial (8 = target+ 6 test + mask)
  {
    currentImage = iImage > 0
    //only if this trial is supposed to present images
    if (isTrialOfType(trialRow, 'image')) {
      var id = images[iImage][trialRow].id;
      if (id) {
        document.getElementById(id).src = images[iImage][trialRow].src;
      }
    }
  }
  onload = showTrial();
}